import { computed, defineComponent } from "vue";
import i18n from "@/lang";
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: "".concat(i18n.t("playTurbo.whole.create"))
        },
        size: {
            type: Number,
            default: 560
        },
        footer: {
            type: Boolean,
            default: true
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var drawerVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        var handleClose = function() {
            emit("update:visible", false);
        };
        return {
            drawerVisible: drawerVisible,
            handleClose: handleClose
        };
    }
});
